module.exports = __webpack_public_path__ + "img/StreamitLogo.ea85bfc4.svg";